// extracted by mini-css-extract-plugin
export default {"countDown":"CustomTimer_countDown__MzlFJ","timer":"CustomTimer_timer__2BSG9","resendButton":"CustomTimer_resendButton__SsLSL"};